<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <h1 class="m-0">
            Campanhas de e-mail marketing

            <a href="/admin/newsletter/nova_campanha" type="button" class="btn btn-info" style="margin-left: 15px">
              <i class="fa-solid fa-plus" style="margin-right: 5px"></i>
              Nova campanha
            </a>

            <a @click="buscarCampanhas" type="button" class="btn btn-info" style="margin-left: 15px">
              <i class="fa-solid fa-rotate-right" style="margin-right: 5px"></i>
              Atualizar
            </a>
          </h1>
        </div>
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item"><a href="/admin/newsletter">Newsletter</a></li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div>
    <!-- TABELA DE registros -->
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Campanhas</h3>
          <div class="card-tools">
            <!-- PAGINAÇÃO  -->
            <ul class="pagination pagination-sm m-0 float-right">
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

              <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
                <a
                  :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'"
                  class="page-link"
                  href="#"
                  @click="selecionarPagina(pagina)"
                >
                  {{ pagina }}
                </a>
              </li>

              <li class="page-item">
                <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
              </li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
            </ul>
          </div>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th>Seq</th>
                <th>Id</th>
                <th>Nome</th>
                <th>Título</th>
                <th>Status</th>
                <th></th>
                <th style="width: 300px; text-align: center; min-width: 300px">Envios</th>
                <th style="width: 300px; text-align: center; min-width: 300px">Ações usuário</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(campanha, index) in campanhas" :key="campanha">
                <td>{{ index + 1 }}</td>
                <td>{{ campanha.id }}</td>
                <td>{{ campanha.campanha_ref }}</td>
                <td>{{ campanha.campanha_titulo }}</td>
                <td>
                  <span v-if="campanha.status == 'Enviando'" class="right badge badge-success">
                    {{ campanha.status }}
                  </span>
                  <span v-else-if="campanha.status == 'Enviando'" class="right badge badge-success">
                    {{ campanha.status }}
                  </span>
                  <span v-else-if="campanha.status == 'Pausada'" style="color: white" class="right badge badge-warning">
                    {{ campanha.status }}
                  </span>
                  <span v-else-if="campanha.status == 'Finalizada'" style="background-color: black" class="right badge badge-danger">
                    {{ campanha.status }}
                  </span>
                  <span v-else style="background-color: gray; color: white" class="right badge badge-warning">
                    {{ campanha.status }}
                  </span>
                </td>
                <td>
                  <button
                    type="submit"
                    :style="campanha.status != 'Criada' && campanha.status != 'Pausada' ? 'background-color: gray; border-color: gray' : ''"
                    class="btn btn-success"
                    @click="iniciarEnvio(campanha)"
                  >
                    <i class="fa-solid fa-play" style="color: white"></i>
                  </button>
                  <button
                    type="submit"
                    :style="campanha.status != 'Enviando' ? 'background-color: gray; border-color: gray' : ''"
                    class="btn btn-warning"
                    @click="pausarEnvio(campanha)"
                  >
                    <i class="fa-solid fa-pause" style="color: white"></i>
                  </button>
                  <button
                    type="submit"
                    class="btn btn-danger"
                    :style="
                      campanha.status == 'Finalizada' ? 'background-color: gray; border-color: gray' : 'background-color: red; border-color: red'
                    "
                    @click="encerrarEnvio(campanha)"
                  >
                    <i class="fa-solid fa-stop" style="color: white"></i>
                  </button>
                </td>
                <td>
                  <div class="row">
                    <div class="col-6" style="min-width: 80px">
                      <span v-if="campanha.status == 'Criada'">
                        <b>Total previsto:</b>
                        {{ campanha.total_emails_lista }}
                      </span>
                      <span v-else>
                        <b>Total:</b>
                        {{ campanha.total_emails }}
                      </span>
                    </div>
                    <div class="col-6">
                      <b>Entregues:</b>
                      {{ campanha.total_entregue }}
                      <span v-if="!campanha.total_emails">(0%)</span>
                      <span v-else>({{ Math.round((campanha.total_entregue * 100) / campanha.total_emails) }}%)</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <b>Enviados:</b>
                      {{ campanha.total_enviado }}
                      <span v-if="!campanha.total_enviado">(0%)</span>
                      <span v-else>({{ Math.round((campanha.total_enviado * 100) / campanha.total_emails) }}%)</span>
                    </div>
                    <div class="col-6">
                      <b>Inválidos:</b>
                      {{ campanha.total_bounced_gt_0 }}
                      <span v-if="!campanha.total_emails">(0%)</span>
                      <span v-else>({{ Math.round((campanha.total_bounced_gt_0 * 100) / campanha.total_emails) }}%)</span>
                    </div>
                  </div>
                </td>

                <td>
                  <div class="row">
                    <div class="col-6">
                      <b>Aberturas:</b>
                      {{ campanha.total_aberturas_gt_0 }}
                      <span v-if="!campanha.total_emails">(0%)</span>
                      <span v-else>({{ Math.round((campanha.total_aberturas_gt_0 * 100) / campanha.total_emails) }}%)</span>
                    </div>
                    <div class="col-6">
                      <b>Reporte SPAM:</b>
                      {{ campanha.total_complaint_gt_0 }}
                      <span v-if="!campanha.total_emails">(0%)</span>
                      <span v-else>({{ Math.round((campanha.total_complaint_gt_0 * 100) / campanha.total_emails) }}%)</span>
                    </div>
                  </div>
                  <div>
                    <b>Cliques:</b>
                    {{ campanha.total_clicks_gt_0 }}
                    <span v-if="!campanha.total_emails">(0%)</span>
                    <span v-else>({{ Math.round((campanha.total_clicks_gt_0 * 100) / campanha.total_emails) }}%)</span>
                  </div>
                </td>

                <td data-label="Ações">
                  <a
                    id="navbarDropdown"
                    class="nav-link"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    v-pre
                  >
                    <i class="fa-solid fa-bars" style="color: gray"></i>
                  </a>

                  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                    <div class="dropdown-divider"></div>
                    <a :href="'/admin/newsletter/detalhes/' + campanha.id" class="dropdown-item" type="submit">
                      <i class="fas fa-search"></i>
                      &nbsp;&nbsp; Visualizar
                    </a>
                    <div class="dropdown-divider"></div>
                    <a @click="validarStatusCampanha(campanha)" class="dropdown-item" type="submit">
                      <i class="fas fa-pen"></i>
                      &nbsp;&nbsp; Editar
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + campanhas.length }}
            <p>Total {{ total }}</p>
          </div>

          <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

          <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
          </select>

          <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 150px"></div>
          </div>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- EDITAR NEWSLETTER -->
  <div
    class="modal fade"
    id="editar-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    @click.self="editar_campanha = false"
    @keydown.esc="editar_campanha = false"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body" v-if="editar_campanha">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
            <admin-editar-newsletter :closeModal="closeModal" :acaoRealizada="acaoRealizada" :campanha="campanha_selecionada" />
          </div>

          <button
            id="editar_campanha"
            type="submit"
            class="btn btn-primary"
            @click="cadastrar_blockname = true"
            data-toggle="modal"
            data-target="#editar-modal"
            style="display: none"
          >
            <i class="fa-solid fa-plus" style="margin-right: 5px"></i>
            Cancelar
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- ADICIONAR NOVO -->
  <div class="modal fade" id="add-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="form-group">
              <label>E-mail</label>
              <input class="form-control" v-model="email_add" />
            </div>

            <div class="form-group">
              <label>Motivo</label>
              <textarea rows="4" cols="50" style="width: 100%" v-model="motivo" class="form-control"></textarea>
            </div>

            <button @click="adicionarNovo" type="submit" class="btn btn-success">Adicionar</button>

            <button style="margin-left: 15px" type="submit" class="btn btn-primary" data-toggle="modal" data-target="#enviar-teste-modal">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import { ca } from "vuetify/locale";

export default {
  props: ["user"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      registro_selecionado: "",
      filtro: "",
      paginas: [],
      registros: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome_contato: "",
      max_page: 0,
      editar_registro: false,
      cadastrar_registro: false,
      campanhas: [],
      editar_campanha: false,
      campanha_selecionada: "",
      email_teste: "",
      email_add: "",
    };
  },

  mounted() {
    this.buscarCampanhas();

    this.email_teste = this.user.email;
    //this.email_teste = "neto.gerardo.1997@gmail.com";
  },

  methods: {
    acaoRealizada(acao) {
      if (acao == "editar") {
        this.editar_campanha = false;
        this.buscarCampanhas();
      }
    },

    closeModal() {
      this.editar_campanha = false;
    },

    adicionarNovo() {
      this.isLoading = true;

      let data = {
        email: this.email_add,
      };

      console.log("URL =");
      console.log(data);

      axios
        .post("/admin/newsletter-email/add", data)
        .then((response) => {
          if (response.data.success) {
            this.isLoading = false;

            this.showSuccessMessageWithButton("Sucesso!", response.data.msg);
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    enviarTeste() {
      this.isLoading = true;

      let data = {
        campanha_id: this.campanha_selecionada.id,
        email: this.email_teste,
      };

      console.log("URL =");
      console.log(data);

      axios
        .post("/admin/newsletter/enviar_teste", data)
        .then((response) => {
          if (response.data.success) {
            this.isLoading = false;

            this.showSuccessMessageWithButton("Sucesso!", response.data.msg);
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    iniciarEnvio(campanha) {
      if (campanha.status != "Finalizada" && campanha.status != "Enviando") {
        let html = "Deseja iniciar ou retomar o envio desta campanha?";

        this.$swal
          .fire({
            title: "Confirmação",
            html: html,
            icon: "info",
            padding: "1.5em",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, quero iniciar!",
          })
          .then((result) => {
            if (result.value) {
              this.isLoading = true;

              let data = {
                campanha_id: campanha.id,
              };

              console.log("URL =");
              console.log(data);

              axios
                .post("/admin/newsletter/iniciar_campanha", data)
                .then((response) => {
                  this.isLoading = false;
                  if (response.data.success) {
                    this.showSuccessMessageWithButton("Sucesso!", response.data.msg);
                    this.buscarCampanhas();
                  } else {
                    this.showErrorMessageWithButton("Ops...", response.data.msg);
                  }
                })
                .catch((error) => {
                  this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                  console.log(error.response.data);
                });
            }
          });
      }
    },

    validarStatusCampanha(campanha) {
      let data = {
        campanha_id: campanha.id,
      };

      console.log("URL =");
      console.log(data);

      axios
        .post("/admin/newsletter/validar_status", data)
        .then((response) => {
          this.isLoading = false;

          if (response.data.success) {
            this.editar_campanha = true;
            this.campanha_selecionada = campanha;

            window.location.href = `/admin/newsletter/editar/${campanha.id}`;

            /*
            this.$nextTick(function () {
              document.getElementById("editar_campanha").click();
            });
            */
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    encerrarEnvio(campanha) {
      if (campanha.status != "Finalizada" && campanha.status != "Enviando") {
        let html = "Deseja realmente finalizar a campanha? Essa ação é irreversível.";

        this.$swal
          .fire({
            title: "Confirmação",
            html: html,
            icon: "warning",
            padding: "1.5em",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, quero finalizar!",
          })
          .then((result) => {
            if (result.value) {
              this.isLoading = true;

              let data = {
                campanha_id: campanha.id,
                status: "Finalizada",
              };

              console.log("URL =");
              console.log(data);

              axios
                .post("/admin/newsletter/update_status", data)
                .then((response) => {
                  this.isLoading = false;

                  if (response.data.success) {
                    this.showSuccessMessageWithButton("Sucesso!", response.data.msg);
                    this.buscarCampanhas();
                  } else {
                    this.showErrorMessageWithButton("Ops...", response.data.msg);
                  }
                })
                .catch((error) => {
                  this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                  console.log(error.response.data);
                });
            }
          });
      }
    },

    pausarEnvio(campanha) {
      if (campanha.status == "Enviando") {
        let html = "Deseja realmente pausar o envio dessa campanha?";

        this.$swal
          .fire({
            title: "Confirmação",
            html: html,
            icon: "info",
            padding: "1.5em",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, quero pausar!",
          })
          .then((result) => {
            if (result.value) {
              this.isLoading = true;

              let data = {
                campanha_id: campanha.id,
                status: "Pausada",
              };

              console.log("URL =");
              console.log(data);

              axios
                .post("/admin/newsletter/update_status", data)
                .then((response) => {
                  this.isLoading = false;

                  if (response.data.success) {
                    this.showSuccessMessageWithButton("Sucesso!", response.data.msg);
                    this.buscarCampanhas();
                  } else {
                    this.showErrorMessageWithButton("Ops...", response.data.msg);
                  }
                })
                .catch((error) => {
                  this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                  console.log(error.response.data);
                });
            }
          });
      }
    },

    buscarCampanhas() {
      this.isLoading = true;

      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("URL =");
      console.log(data);

      axios
        .post("/admin/newsletter/search", data)
        .then((response) => {
          this.campanhas = response.data.campanhas;
          this.total = response.data.total;

          this.isLoading = false;

          console.log(this.campanhas);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    limparFiltros() {
      this.objeto = null;
      this.registros = [];
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);
      console.log("Max = " + this.max_page);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarRegistros();
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
